import { defineMessages } from 'react-intl-next';

export default defineMessages({
	heading: {
		id: 'unknown-error-page.title.non-final',
		defaultMessage: 'Something went wrong',
		description: 'Title for the generic error page',
	},
	message: {
		id: 'unknown-error-page.message.non-final',
		defaultMessage:
			'Try again later or check <Link>status.atlassian.com</Link> for the latest updates.',
		description: 'Message for the generic error page',
	},
	imageAlt: {
		id: 'unknown-error-page.image-alt',
		defaultMessage: 'unknown error illustration',
		description: 'Alt text for the unknown error',
	},
	action: {
		id: 'unknown-error-page.action',
		defaultMessage: 'View status page',
		description: 'text for the action view status page button',
	},
});
